import React from "react";
import PropTypes from "prop-types";


function ModalInput(props) {
  const handleInputChange = (event) => {
    props.onInputChange(props.parameter.name, event.target.value);
  };

  return (
    <div id="tryout-parameter-path-key-value" className="tryout-parameter-path-key-value">
      <div id="tryout-parameter-path-key-value_jobId" className="parameters">
        <label htmlFor="tryout-parameter-path-key-value_input_jobId">
          {/* {props.parameter.name} */}
          {props.parameter.name}
        </label>
        <input id="tryout-parameter-path-key-value_input_jobId" className="required-parameter"
          placeholder="value"
          value={props.value || ""}
          onChange={handleInputChange}
        ></input>
      </div>
    </div>
  );
}
ModalInput.propTypes = {
  // name: PropTypes.string,
  // desc: PropTypes.string,
  parameter: PropTypes.object,
  onInputChange: PropTypes.func.isRequired,
};

export default ModalInput;
